<template>
  <div class="batch_order_new">
    <el-dialog
        lock-scroll
        :modal-append-to-body="false"
        :append-to-body="true"
        :title="$lang('编辑订单')"
        :close-on-click-modal="false"
        top="45px"
        custom-class="j-dialog"
        class="edit_success_dialog"
        :visible.sync="visible"
        @close="close"
        width="960px"
    >
      <div class="overflow">
        <el-form class="el-form-edit" ref="orderForm" :rules="rules" :inline="true" :model="resultForm" label-position="left">
          <h3 class="title_h3">{{ $lang('寄件人信息') }}</h3>
          <div class="group-content">
            <el-form-item :label="$lang('国家')" prop="senderCountryName">
              <el-select filterable v-model="resultForm.senderCountryName" @change="changeCountryName($event, 'senderPhoneAreacode')">
                <el-option v-for="item in sendCity" :key="item.code" :label="item.name" :value="item.code"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$lang('姓名')" prop="senderName">
              <el-input v-model="resultForm.senderName" :placeholder="$lang('请输入')" :minlength="1" :maxlength="30"></el-input>
            </el-form-item>
            <el-form-item :label="$lang('手机')" prop="senderMobilePhone">
              <el-input v-model="resultForm.senderMobilePhone" :placeholder="$lang('请输入')" :maxlength='15'></el-input>
            </el-form-item>
            <el-form-item :label="$lang('公司')" prop="senderCompany">
              <el-input v-model="resultForm.senderCompany" :placeholder="$lang('请输入')" :minlength="1" :maxlength='100'></el-input>
            </el-form-item>
            <el-form-item :label="$lang('邮箱')" prop="senderEmail">
              <el-input v-model="resultForm.senderEmail" :placeholder="$lang('请输入')" :minlength="1" :maxlength='150'></el-input>
            </el-form-item>
            <el-form-item :label="$lang('寄件酋长国')" prop="senderProvinceName">
              <el-select filterable v-model="resultForm.senderProvinceName" @change="dataProvinceChange($event, 1)">
                <el-option v-for="item in provinceArray" :key="item.id" :label="item.nativeName" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item :label="$lang('寄件城市')" prop="senderCityName">
              <el-select filterable v-model="resultForm.senderCityName" @change="dataCityChange($event, 1)">
                <el-option v-for="item in cityList" :key="item.id" :label="item.nativeName" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item :label="$lang('寄件区域')" prop="senderAreaName">
              <el-select filterable v-model="resultForm.senderAreaName" @change="dataAreaChange($event, 1)">
                <el-option v-for="item in areaList" :key="item.id" :label="item.nativeName" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item :label="$lang('寄件街道')" prop="senderStreet">
              <el-input v-model.trim="resultForm.senderStreet" :placeholder="$lang('请输入')" :minlength="1" :maxlength="12"></el-input>
            </el-form-item>
            <el-form-item class="el-form-item item-col-6 el-form-item--small special_textarea" :label="$lang('详细地址')" prop="senderDetailedAddress">
              <el-input v-model="resultForm.senderDetailedAddress" type="textarea" :placeholder="$lang('请输入')" :minlength="4" :maxlength="200"></el-input>
            </el-form-item>
          </div>
          <h3 class="title_h3">{{ $lang('收件人信息') }}</h3>
          <div class="group-content">
            <el-form-item :label="$lang('国家')" prop="receiverCountryName">
              <el-select filterable v-model="resultForm.receiverCountryName">
                <el-option v-for="item in receiveList" :key="item.countryName" :label="item.countryName" :value="item.countryName"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$lang('姓名')" prop="receiverName">
              <el-input v-model="resultForm.receiverName" :placeholder="$lang('请输入')" :minlength="1" :maxlength="30"></el-input>
            </el-form-item>
            <el-form-item :label="$lang('手机')" prop="receiverMobilePhone">
              <el-input v-model="resultForm.receiverMobilePhone" :placeholder="$lang('请输入')" :maxlength="15"></el-input>
            </el-form-item>
            <el-form-item :label="$lang('证件号')" prop="receiverIdCard">
              <el-input v-model="resultForm.receiverIdCard" :placeholder="$lang('请输入')" :minlength="1" :maxlength="30"></el-input>
            </el-form-item>

            <el-form-item :label="$lang('邮箱')" prop="receiverEmail">
              <el-input v-model="resultForm.receiverEmail" :placeholder="$lang('请输入')" :minlength="1" :maxlength="150"></el-input>
            </el-form-item>
            <el-form-item :label="$lang('公司')" prop="receiverCompany">
              <el-input v-model="resultForm.receiverCompany" :placeholder="$lang('请输入')" :minlength="1" :maxlength="150"></el-input>
            </el-form-item>
            <el-form-item :label="$lang('邮编')" prop="receiverPostalCode">
              <el-input  v-model="resultForm.receiverPostalCode" :placeholder="$lang('请输入')" :minlength="1" :maxlength="60"></el-input>
            </el-form-item>
            <el-form-item :label="$lang('收件省份')" prop="receiverProvinceName">
              <el-input  v-model="resultForm.receiverProvinceName" :placeholder="$lang('请输入')"></el-input>
            </el-form-item>
            <el-form-item :label="$lang('收件城市')" prop="receiverCityName">
              <el-input  v-model="resultForm.receiverCityName" :placeholder="$lang('请输入')"></el-input>
            </el-form-item>
            <el-form-item :label="$lang('收件区域')" prop="receiverAreaName">
              <el-input  v-model="resultForm.receiverAreaName" :placeholder="$lang('请输入')"></el-input>
            </el-form-item>
            <el-form-item :label="$lang('收件街道')" prop="receiverStreet">
              <el-input v-model.trim="resultForm.receiverStreet" :placeholder="$lang('请输入收件街道')" :minlength="1" :maxlength="12"></el-input>
            </el-form-item>
            <el-form-item class="el-form-item item-col-6 el-form-item--small special_textarea" :label="$lang('详细地址')" prop="receiverDetailedAddress">
              <el-input v-model="resultForm.receiverDetailedAddress" type="textarea" :placeholder="$lang('请输入')" :minlength="4" :maxlength="200"></el-input>
            </el-form-item>
          </div>
          <h3 class="title_h3">{{ $lang('货物信息') }}</h3>
          <div class="group-content">
            <el-form-item :label="$lang('物品价值')" prop="declaredValue">
              <el-input-number v-model="resultForm.declaredValue"></el-input-number>
            </el-form-item>
            <el-form-item :label="$lang('申报币别')" prop="codCurrencyTypeCode">
              <el-select filterable v-model="resultForm.codCurrencyTypeCode">
                <el-option v-for="item in codCurrencyType" :key="item.codCurrencyTypeCode" :label="item.codCurrencyTypeName" :value="item.codCurrencyTypeCode"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$lang('物品类型')" prop="goodsTypeCode">
              <el-select filterable v-model="resultForm.goodsTypeCode">
                <el-option v-for="item in goodsTypeList" :key="item.code" :label="item.name" :value="item.code"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$lang('长(cm)')" prop="packageLength">
              <el-input-number v-model="resultForm.packageLength" :precision="2" :min="0" :max="9999999.99"></el-input-number>
            </el-form-item>
            <el-form-item :label="$lang('宽(cm)')" prop="packageWide">
              <el-input-number v-model="resultForm.packageWide" :precision="2" :min="0" :max="9999999.99"></el-input-number>
            </el-form-item>
            <el-form-item :label="$lang('高(cm)')" prop="packageHigh">
              <el-input-number v-model="resultForm.packageHigh" :precision="2" :min="0" :max="9999999.99"></el-input-number>
            </el-form-item>
            <el-form-item :label="$lang('备注')" prop="remarks" style="width: 860px">
              <el-input type="textarea" v-model="resultForm.remarks" :maxlength="50" :label="$lang('描述文字')"></el-input>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="dialog-footer">
        <el-button type="primary" :loading="btnLoading" @click="submitHandle" class="h40">{{ $lang('保 存') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { RESPONSE_SUCCESS } from '@constants'
import { mapGetters, mapState } from 'vuex'
import { RULES, phoneAndMobileInter, checkAddressFormat } from '@utils/rules'
import { getComCost, getSettlement, getsysCurrencyType } from '@/api/module/customer'
import debounce from 'lodash/debounce'
import * as Api from '@api/base/public'
import { batchOrderNew } from '@views/international/batch-order-new/pool'

export default {
  name: 'EditOrder',
  props: {
    orderData: {
      type: Object,
      default: function () {
        return {}
      },
    }
  },
  data () {
    return {
      btnLoading: false,
      resultForm: {},
      visible: false,
      provinceArray: [],
      cityList: [],
      startAddressId: null,
      endAddressId: null,
      senderExpressTypeData: [],
      receiverExpressTypeData: [],
      goodsTypeList: [],
      rules: {
        senderCountryCode: [RULES.requiredSelect],
        senderName: [RULES.requiredTrim],
        senderMobilePhone: [RULES.required, { validator: phoneAndMobileInter }],
        senderEmail: [{ type: 'email', message: this.$lang('请输入正确的邮箱地址'), trigger: ['blur', 'change'] }],
        senderProvinceName: [RULES.requiredSelect],
        senderCityName: [RULES.requiredSelect],
        senderDetailedAddress: [RULES.required, { validator: checkAddressFormat }],
        receiverCountryName: [RULES.requiredSelect],
        receiverName: [RULES.requiredTrim],
        receiverMobilePhone: [RULES.required, { validator: phoneAndMobileInter }],
        receiverEmail: [{ type: 'email', message: this.$lang('请输入正确的邮箱地址'), trigger: ['blur', 'change'] }],
        receiverPostalCode: [RULES.requiredTrim],
        receiverProvinceName: [RULES.requiredSelect],
        receiverCityName: [RULES.requiredSelect],
        receiverDetailedAddress: [RULES.required, { validator: checkAddressFormat }],
        declaredValue: [RULES.required, RULES.goodMoney],
        codCurrencyTypeCode: [RULES.requiredSelect],
        goodsTypeCode: [RULES.requiredSelect]

      },
      codCurrencyType: [],
      areaList: [],
      receiveList: [],
      sendCity: [{ code: this.$lang('UAE'), name: this.$lang('UAE') }]
    }
  },
  watch: {
    orderData: {
      handler (val) {
        this.resultForm = { ...val }
        this.$nextTick(_ => {
          this.getProList(this.resultForm.senderCountryId || '')
          this.getCurrencyTypeList()
          this.getGoodType()
          this.getReceiveCity()
          if (this.resultForm.senderProvinceId) {
            this.handleProvice(this.resultForm.senderProvinceId, 1)
          }
        })
      },
      deep: true,
    }
  },
  computed: {
    ...mapState({
      countryList: state => state.base.countryList
    }),
    ...mapGetters({
      user: 'user',
    })
  },
  methods: {
    async getReceiveCity() {
      const { code, data } = await batchOrderNew.reqReceive()
      if (code === 1) {
        this.receiveList = data || []
      } else {
        this.receiveList = []
      }
    },
    openSuc() {
      this.visible = true
    },
    async getGoodType() {
      const { code, data } = await batchOrderNew.reqGood()
      if (code === 1) {
        this.goodsTypeList = data.appArticleTypeVOList || []
      } else {
        this.goodsTypeList = []
      }
    },
    async submitHandle() {
      this.btnLoading = true
      if (this.resultForm.payment) {
        const paymentkey = Object.keys(this.resultForm.payment).some((item) => {
          return this.resultForm.payment[item] === null
        })
        if (paymentkey) {
          this.resultForm.payment = null
        }
      }
      if (this.resultForm.goods) {
        const goodskey = Object.keys(this.resultForm.goods).some((item) => {
          return this.resultForm.goods[item] === null
        })
        if (goodskey) {
          this.resultForm.goods = null
        }
      }
      await this.$emit('edit-success-save', this.resultForm, 1)
      this.btnLoading = false
    },
    close() {
      this.resultForm = {}
      this.btnLoading = false
      this.visible = false
    },
    changeCountryName (code, key) {
      if (this.countryList.length > 0) {
        const obj = this.countryList.find(item => item.code === code)
        this.resultForm[key] = obj.areaCode
        this.getProList(obj.id || '')
        this.clearCity('sender')
        this.clearProvince('sender')
      }
    },
    async getProList (countryId) {
      const { data, code, msg } = await Api.GET_AREA_INTER({ current: 1, size: 9999, type: 2, countryId })
      if (code === RESPONSE_SUCCESS) {
        this.provinceArray = data || []
      } else {
        this.$message.error(msg)
      }
    },
    clearCity (type) {
      if (type === 'sender') {
        this.resultForm.senderCityId = ''
        this.resultForm.senderCityName = ''
      } else {
        this.resultForm.receiverCityId = ''
        this.resultForm.receiverCityName = ''
      }
    },
    clearProvince (type) {
      if (type === 'sender') {
        this.resultForm.senderProvinceId = ''
        this.resultForm.senderProvinceName = ''
      } else {
        this.resultForm.receiverProvinceId = ''
        this.resultForm.receiverProvinceName = ''
      }
    },
    dataProvinceChange (value, flag) {
      if (value) {
        this.getCityList(value, flag)
      }
      if (flag === 1) {
        this.resultForm.senderAreaName = ''
        this.resultForm.senderAreaId = ''
      } else {
        this.resultForm.receiverAreaName = ''
        this.resultForm.receiverAreaId = ''
      }
    },
    async getCityList (parentId, flag) {
      const { data, code, msg } = await Api.GET_AREA_INTER({ current: 1, size: 9999, type: 3, parentId: parentId })
      if (code === RESPONSE_SUCCESS) {
        if (flag === 1) {
          this.cityList = data || []
          this.resultForm.senderProvinceId = parentId
          this.resultForm.senderCityId = data[0].id
          this.resultForm.senderCityName = data[0].nativeName
          let obj = {}
          obj = this.provinceArray.find((item) => {
            return item.id === parentId
          })
          this.resultForm.senderProvinceName = obj.nativeName
          this.senderExpressTypeData = data[0].products || []
        } else {
          this.cityList2 = data || []
          this.resultForm.receiverProvinceId = parentId
          this.resultForm.receiverCityId = data[0].id
          this.resultForm.receiverCityName = data[0].nativeName
          this.receiverExpressTypeData = data[0].products || []
        }
        this.getAreaList(data[0].id, flag)
      } else {
        this.$message.error(msg)
      }
    },
    dataCityChange (value, num) {
      if (num === 1) {
        this.resultForm.senderCityId = value
        if (this.cityList.length > 0) {
          const obj = this.cityList.find((item) => {
            return item.id === value
          })
          this.resultForm.senderCityName = obj.nativeName
          this.senderExpressTypeData = obj.products || []
        }
      } else {
        this.resultForm.receiverCityId = value
        if (this.cityList2.length > 0) {
          const obj = this.cityList2.find((item) => {
            return item.id === value
          })
          this.resultForm.receiverCityName = obj.nativeName
          this.receiverExpressTypeData = obj.products || []
        }
      }
      this.getAreaList(value, num)
    },
    async getAreaList(parentId, flag) {
      const { data, code, msg } = await Api.GET_AREANEW({ current: 1, size: 9999, type: 4, parentId: parentId })
      if (code === RESPONSE_SUCCESS) {
        if (data && data.length > 0) {
          if (flag === 1) {
            this.areaList = data
            this.resultForm.senderAreaName = data[0].nativeName
            this.resultForm.senderAreaId = data[0].id
          } else {
            this.areaList2 = data
            this.resultForm.receiverAreaName = data[0].nativeName
            this.resultForm.receiverAreaId = data[0].id
          }
        }
      } else {
        this.$message.error(msg)
      }
    },
    dataAreaChange(value, flag) {
      if (flag === 1) {
        this.resultForm.senderAreaId = value
        const obj = this.areaList.find((item) => {
          return item.id === value
        })
        this.resultForm.senderAreaName = obj.nativeName
      } else {
        this.resultForm.receiverAreaId = value
        const obj = this.areaList2.find((item) => {
          return item.id === value
        })
        this.resultForm.receiverAreaName = obj.nativeName
      }
    },
    async handleProvice (provinceId, flagType) {
      const { data, code, msg } = await Api.GET_AREA_INTER({ current: 1, size: 9999, type: 3, parentId: provinceId })
      if (code === RESPONSE_SUCCESS) {
        if (flagType === 1) {
          this.cityList = data || []
          const item = data.find(({ id }) => id === this.resultForm.senderCityId)
          if (item) this.senderExpressTypeData = item.products || []
        } else {
          this.cityList2 = data || []
          const item = data.find(({ id }) => id === this.resultForm.receiverCityId)
          if (item) this.receiverExpressTypeData = item.products || []
        }
      } else {
        this.$message.error(msg)
      }
    },
    calcStandardCost: debounce(async function (data) {
      const { senderProvinceId, senderCityId, receiverCityId, receiverProvinceId, paymentModeId, expressTypeCode } = data
      const obj = {}
      const promises = [
        await this.getSettlement(senderProvinceId, senderCityId),
        await this.getSettlement(receiverProvinceId, receiverCityId),
      ]
      const [startAddressId, endAddressId] = await Promise.all(promises)
      if (startAddressId && endAddressId && expressTypeCode) {
        const res = await this.getComCost(startAddressId, endAddressId, paymentModeId, expressTypeCode)
        obj.standardValue = res.cost
        obj.settlementWeight = res.setWeight
        this.resultForm.standardValue = res.cost
        this.resultForm.settlementWeight = res.setWeight
      }
    }, 200),
    async getSettlement (providerId, cityId, areaId, type) {
      const reqData = { providerId, cityId, areaId }
      const { code, data } = await getSettlement(reqData)
      if (code === 1 && data) {
        const id = data.id
        return id
      } else {
        return ''
      }
    },
    // 运费计算
    async getComCost (number, startAddressId, endAddressId, paymentModeId, productTypeCode) {
      let smMode = 2
      if (paymentModeId) {
        switch (paymentModeId) {
          case 320:
            smMode = 1
            break
          case 319:
            smMode = 2
            break
          case 321:
            smMode = 3
            break
        }
      }
      const reqData = { startAddressId, endAddressId, number, smMode, productTypeCode, serviceMethodCode: '01' }
      const { data = 0 } = await getComCost(reqData)
      return data || 0
    },
    async getCurrencyTypeList () {
      const { data, code, msg } = await getsysCurrencyType()
      const dataList = []
      if (code === RESPONSE_SUCCESS) {
        for (let p = 0; p < data.length; p++) {
          dataList.push({ codCurrencyTypeCode: data[p].coding, codCurrencyTypeName: data[p].name })
        }
        this.codCurrencyType = dataList
        this.resultForm.codCurrencyTypeName = this.codCurrencyType[0].codCurrencyTypeName // 代收货款币别
        this.resultForm.codCurrencyTypeCode = this.codCurrencyType[0].codCurrencyTypeCode // 代收货款币别code
      } else {
        this.$message.error(msg)
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.edit_success_dialog {
  ::v-deep .title_h3 {
    display: flex;
    align-items: center;
    height: 40px;
    line-height: 40px;
    box-sizing: border-box;
    background: #FAFAFA;
    padding: 12px;
    border-bottom: 1px solid #ddd;
    position: relative;
  }
  .dialog-footer {
    border-top: 0;
    margin-top: 0px;
    margin-bottom: 20px;

    .el-button {
      min-width: 200px;
      height: 40px;
    }
  }
  ::v-deep {
    .special_textarea {
      width: 500px;
    }
  }
}
.group-title {
  border-bottom: 1px dashed #eeeeee;
  margin: 0 10px 20px 10px;
  padding: 16px 0px;
  .title {
    font-size: 14px;
    color: #333;
    font-weight: 600;
    display: inline-block;
    line-height: 7px;
    border-bottom: 4px solid #e0bd7b;
  }
  .insert-info {
    display: inline-block;
    margin-left: 60px;
    position: relative;
    .icon {
      color: #e0bd7b;
      position: absolute;
      overflow: visible;
    }
    .text {
      color: #666666;
      margin-left: 20px;
    }
  }
}
.el-form-item {
  padding: 0px 8px 18px 8px !important;
}
.group-content {
  background: #f7f7f9;
  padding: 20px 20px 10px;
  border-radius: 8px;
}
.w360 .el-input {
  width: 360px !important;
}
</style>
<style lang="scss">
.el-dialog__wrapper .el-dialog.j-dialog {
  margin-bottom: 0 !important;
}
.el-dialog__wrapper .el-dialog.j-dialog .el-dialog__body {
  max-height: 700px;
  overflow: auto;
  padding: 10px 20px;
}
</style>
